export default async function getExcursions({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'excursions');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
